import {
  TireHotelRehomeSellerMembershipOutcome,
  TireHotelRehomeSettlement,
  TireHotelSellerInboundMode
} from '@navio/nsdk';
import type { NoddiIconName } from 'noddi-ui-common';
import { TIRE_HOTEL_SELLER_INBOUND_MODE_OPTIONS } from 'noddi-util';

/** "Does the seller keep a tire hotel?" in plain words. */
export const SELLER_MEMBERSHIP_OPTIONS = [
  {
    value: TireHotelRehomeSellerMembershipOutcome.END,
    label: 'No, end it',
    description: 'The seller is done with us.',
    icon: 'CircleX' as const
  },
  {
    value: TireHotelRehomeSellerMembershipOutcome.KEEP,
    label: 'Yes, on their new car',
    description: 'The rest of the paid period moves to the new car.',
    icon: 'Car' as const
  }
];

/** "Who pays for the buyer's tire hotel?" in plain words. */
export const SETTLEMENT_OPTIONS = [
  {
    value: TireHotelRehomeSettlement.BUYER_PAYS,
    label: 'The buyer',
    description: 'They get an SMS to approve and pay. Their tire hotel starts when they pay.',
    icon: 'CreditCard' as const
  },
  {
    value: TireHotelRehomeSettlement.STAFF_COMP,
    label: 'Nobody, we do it now',
    description: 'Free for the buyer. Their tire hotel starts right away.',
    icon: 'Gift' as const
  }
];

const SELLER_INBOUND_MODE_ICON: Record<TireHotelSellerInboundMode, NoddiIconName> = {
  [TireHotelSellerInboundMode.NONE]: 'CircleX',
  [TireHotelSellerInboundMode.CUSTOMER_DROP_OFF]: 'Warehouse',
  [TireHotelSellerInboundMode.PAID_PICKUP]: 'Truck'
};

/** How the seller's replacement set arrives, with an icon per choice. */
export const SELLER_INBOUND_MODE_OPTIONS = TIRE_HOTEL_SELLER_INBOUND_MODE_OPTIONS.map((option) => ({
  ...option,
  icon: SELLER_INBOUND_MODE_ICON[option.value]
}));
